import { jsx as _jsx } from "react/jsx-runtime";
import { Drawer, useMediaQuery, useTheme } from '@mui/material';
import ChatHistory from '../../../chat-history';
var ChatHistoryDrawer = function (_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen;
    var theme = useTheme();
    var handleClose = function () { return setIsOpen(false); };
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    return (_jsx(Drawer, { anchor: isXs ? 'bottom' : 'left', open: isOpen, onClose: handleClose, sx: {
            '& .MuiDrawer-paper': {
                height: '100%',
                width: !isXs ? '400px' : undefined,
                overflow: 'hidden'
            }
        }, children: _jsx(ChatHistory, { closeDrawer: handleClose }) }));
};
export default ChatHistoryDrawer;
